export const evenValues =
  '3832616587,741921187,1093640920,148794350,188737304,657561874,579291088,940393563,429995750,4116007870,4069692405,2021537106,3649382234';

export const oddValues =
  '397166282,2845626946,3197346679,4117058733,1906740087,1481122353,1402851567,940393563,1299843205, 3325204637,3025783732,2891384561,682279193';

export const sortingOdd = [
  '397166282',
  '2845626946',
  '1906740087',
  '4117058733',
  '1481122353',
  '1402851567',
  '940393563',
  '3197346679',
  '1299843205',
  '3325204637',
  '3025783732',
];

export const sortingEven = [
  '3832616587',
  '741921187',
  '188737304',
  '148794350',
  '657561874',
  '579291088',
  '940393563',
  '1093640920',
  '429995750',
  '4116007870',
  '4069692405',
];

export const trunkOptions = [
  { label: 'Inband IQ', value: 'b' },
  { label: 'Inband GD', value: 'a' },
  { label: 'TDM', value: 'c' },
  { label: 'Gizmo', value: 'e' },
  { label: 'TouchTone', value: 'f' },
  { label: 'Rapid Response', value: 'g' },
  { label: 'Verizon', value: 'h' },
  { label: 'Katy ISD', value: 'i' },
  { label: 'Analog TDM', value: 'j' },
];

export const timezoneOptions = [
  { label: 'EST', value: 'est', toolTip: "Eastern Standard Time New York (GMT-5)" },
  { label: 'CST', value: 'cst', toolTip: "Central Standard Time Chicago (GMT-6)" },
  { label: 'MST', value: 'mst', toolTip: "Mountain Standard Time Denver (GMT-7) " },
  { label: 'PST', value: 'pst', toolTip: "Pacific Standard Time Los Angeles (GMT-8)" },
  { label: 'AST', value: 'ast', toolTip: "Alaska Standard Time Anchorage (GMT-9)" },
  { label: 'HST', value: 'hst', toolTip: "Hawaii Standard Time Honolulu (GMT-10) " },
];
export const arrayType = [
  'modem',
  'hunt',
  'faxStandard',
  'fax',
  'fireAlarm',
  'alarm',
  'elevator',
  'voice',
  'ringDown',
  'modemHunt'
];

export const dialToneOnly = 'dialToneOnly'
